var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 112,
    viewBox: "0 0 210 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty company",
    clipPath: "url(#clip0_23715_17004)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 112,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 41123"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3364",
    x: 60,
    y: 64,
    width: 30,
    height: 16,
    fill: "url(#paint0_linear_23715_17004)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3365",
    x: 90,
    y: 16,
    width: 30,
    height: 16,
    fill: "url(#paint1_linear_23715_17004)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3366",
    x: 120,
    y: 32,
    width: 30,
    height: 16,
    fill: "url(#paint2_linear_23715_17004)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3367",
    x: 150,
    y: 64,
    width: 30,
    height: 16,
    fill: "url(#paint3_linear_23715_17004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.75 112V96.25H0V95.75H29.75L29.75 80.25H0V79.75H29.75V64.25H0V63.75H29.75L29.75 48.25H0V47.75H29.75V32.25H0V31.75H29.75L29.75 16.25H0V15.75H29.75V0H30.25V15.75H59.75V0H60.25V15.75H89.75V0H90.25V15.75H119.75V0H120.25V15.75H149.75V0H150.25V15.75H179.75V0H180.25V15.75H210V16.25H180.25V31.75H210V32.25H180.25V47.75H210V48.25H180.25V63.75H210V64.25H180.25V79.75H210V80.25H180.25V95.75H210V96.25H180.25V112H179.75V96.25H150.25V112H149.75V96.25H120.25V112H119.75V96.25H90.25V112H89.75V96.25H60.25V112H59.75V96.25H30.25V112H29.75ZM179.75 95.75V80.25H150.25V95.75H179.75ZM179.75 79.75V64.25H150.25V79.75H179.75ZM179.75 63.75V48.25H150.25V63.75H179.75ZM179.75 47.75V32.25H150.25V47.75H179.75ZM179.75 31.75V16.25H150.25V31.75H179.75ZM120.25 16.25H149.75V31.75H120.25V16.25ZM120.25 32.25H149.75V47.75H120.25V32.25ZM120.25 48.25H149.75V63.75H120.25L120.25 48.25ZM120.25 64.25H149.75V79.75H120.25V64.25ZM120.25 80.25H149.75V95.75H120.25V80.25ZM119.75 95.75V80.25H90.25V95.75H119.75ZM119.75 79.75V64.25H90.25V79.75H119.75ZM119.75 63.75L119.75 48.25H90.25L90.25 63.75H119.75ZM119.75 47.75V32.25H90.25V47.75H119.75ZM119.75 31.75V16.25H90.25V31.75H119.75ZM60.25 16.25H89.75V31.75H60.25V16.25ZM60.25 32.25H89.75V47.75H60.25V32.25ZM60.25 48.25H89.75L89.75 63.75H60.25L60.25 48.25ZM60.25 64.25H89.75V79.75H60.25V64.25ZM60.25 80.25H89.75V95.75H60.25V80.25ZM59.75 95.75V80.25H30.25L30.25 95.75H59.75ZM59.75 79.75V64.25H30.25V79.75H59.75ZM59.75 63.75L59.75 48.25H30.25L30.25 63.75H59.75ZM59.75 47.75V32.25H30.25V47.75H59.75ZM59.75 31.75V16.25H30.25L30.25 31.75H59.75Z",
    fill: "url(#paint4_radial_23715_17004)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M86.65 34H109.75C110.585 34 111.276 34.6207 111.385 35.4261L111.4 35.65V40.6H122.95C123.861 40.6 124.6 41.3387 124.6 42.25V76.9C124.6 77.5075 124.108 78 123.5 78H116.9C116.292 78 115.8 77.5075 115.8 76.9V69.2H109.2V76.9C109.2 77.5075 108.708 78 108.1 78H101.5C100.892 78 100.4 77.5075 100.4 76.9V42.25C100.4 41.3387 101.139 40.6 102.05 40.6H108.1V37.3H88.3V76.35C88.3 77.2613 87.5613 78 86.65 78C85.8147 78 85.1243 77.3793 85.0151 76.5739L85 76.35V35.65C85 34.8147 85.6207 34.1243 86.4261 34.0151L86.65 34ZM96 67V71.4H91.6V67H96ZM96 60.4V64.8H91.6V60.4H96ZM111.4 60.4H107V64.8H111.4V60.4ZM118 60.4H113.6V64.8H118V60.4ZM96 53.8V58.2H91.6V53.8H96ZM111.4 53.8H107V58.2H111.4V53.8ZM118 53.8H113.6V58.2H118V53.8ZM96 47.2V51.6H91.6V47.2H96ZM111.4 47.2H107V51.6H111.4V47.2ZM118 47.2H113.6V51.6H118V47.2ZM96 40.6V45H91.6V40.6H96Z",
    fill: "url(#paint5_linear_23715_17004)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23715_17004",
    x1: 75,
    y1: 64,
    x2: 75,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F8",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23715_17004",
    x1: 105,
    y1: 16,
    x2: 105,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F8",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23715_17004",
    x1: 135,
    y1: 32,
    x2: 135,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F8",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_23715_17004",
    x1: 165,
    y1: 64,
    x2: 165,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F8",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_23715_17004",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105 56) rotate(90) scale(56 105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D8E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_23715_17004",
    x1: 104.8,
    y1: 34,
    x2: 104.8,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9DAA",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23715_17004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 112,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCompany);
export default __webpack_public_path__ + "static/media/empty_company.da6c535ac3bc36dc86bdde61ebb6604e.svg";
export { ForwardRef as ReactComponent };